import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import { Avatar, Loader } from "../../../../core/atoms/atoms";
import { ContentCard } from "@travellocal/ui";
import { UpsellCard } from "../../../../shared/components/inspiration/cards";
import { CollectionKeyHelper } from "../../../../shared/helpers/contentCollectionHelpers";
import { MatchState } from "../../../../shared/helpers/reduxHelpers";
import * as StringUtil from "../../../../shared/helpers/stringHelpers";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./countryOurExperts.scss";

interface StateProps {
  currency: IState<IBaseCurrency>;
  ltoState: IState<ILto>;
  contentState: IKeyedState<IPagerState<IContent>>;
  countryState: IState<ILocation>;
}

type Props = StateProps;

export class CountryOurExpertsComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const { ltoState, contentState, countryState } = this.props;

    const country = countryState.data as ICountry;
    if (countryState.status !== "OK") {
      return <Loader />;
    }

    const lto = ltoState.data;
    if (!lto) {
      const subject = countryState.data ? `Enquiry about ${countryState.data.name}` : "Enquiry";
      const mailtoLink = `mailto:team@travellocal.com?subject=${subject}`;
      return (
        <div className="p-top-large p-bottom-large">
          <div className="width-wrapper">
            <h1>Coming soon</h1>
            <p>If you're thinking of planning a trip here, send us an email at <a href={mailtoLink}>team@travellocal.com</a>, and we'd be happy to help you further!</p>
          </div>
        </div>
      );
    }

    const countryReviewsState = contentState.data[CollectionKeyHelper.LocationReviews(country.id)];

    const ltoImageUrl = lto.image ? lto.image.regularUrl : "/images/missing-image.jpg";
    const ltoDisplayName = lto.publicName || lto.name;
    const ltoDisplaySpeciality = lto.publicSpeciality || lto.speciality;
    const ltoDisplayDescription = lto.publicDescription || lto.description;

    return (
      <div className="country-our-experts">
        <Helmet title={country.ltoPageTitleTag}
          meta={[
            { name: "description", content: country.ltoPageDescriptionTag },
          ]}
          link={[
            { rel: "canonical", href: `${globalConfig.wwwBaseUrl}${WebRoutes.countryExperts(country.slug, country.parent.slug)}` },
          ]}
        />

        <div className="width-wrapper country-content-wrapper columns is-multiline is-marginless">
          <div className="column is-full-tablet is-9-desktop content profile">
            <Avatar source={ltoImageUrl} size={Avatar.UISizes.xlarge} />
            <h2>
              {StringUtil.capitalize(ltoDisplayName)}
            </h2>
            <p className="specialty">{ltoDisplaySpeciality}</p>
            <p>{ltoDisplayDescription}</p>
          </div>

          <div className="column is-full-tablet is-3-desktop sidebar">
            {MatchState(countryReviewsState, {
              ok: () => {
                const featuredReview = countryReviewsState.data[0];
                
                if (featuredReview != null) {
                  return (
                    <div>
                      <ContentCard content={featuredReview} filterContext={{ locations: [country.id] }} />
                      <hr />
                      <Link className="read-more-link" to={WebRoutes.countryReviews(country.slug, country.parent.slug)}>See all customer reviews...</Link>
                    </div>
                  );
                }
                else {
                  return <UpsellCard />;
                }
              },
            })}

            {country.externalLinks && country.externalLinks.map((link, i) => (
              <a
                key={`read-more-${i}`}
                className="read-more-link"
                href={link.url}
                target="_blank"
              >{link.text}</a>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IWebStoreState): StateProps => ({
  countryState: state.country,
  ltoState: state.lto, // TODO Ignore all non-default LTOs until this page is redesigned
  contentState: state.contentByCollection,
  currency: state.currency,
});

export const OurExperts = connect(mapStateToProps, null)(CountryOurExpertsComponent);
